<template>
  <footer :class="['home-footer', { 'active': showImageFooter }]" ref="footer">
    <div class="footer-main">
      <div class="footer-main-item">
        <h2 class="footer-main-title">مقالات</h2>
        <ul class="footer-list">
          <li class="footer-list__item">
            <router-link to="/medicinal">عسل درمانی</router-link>
          </li>
          <li class="footer-list__item">
            <router-link to="/produce">نحوه تولید عسل</router-link>
          </li>
          <li class="footer-list__item">
            <router-link to="/detect">تشخیص عسل طبیعی</router-link>
          </li>
        </ul>
      </div>

      <div class="footer-main-item">
        <h2 class="footer-main-title">محصولات</h2>
        <ul class="footer-list">
          <li class="footer-list__item">
            <router-link to="/product">عسل چهل گیاه</router-link>
          </li>
          <li class="footer-list__item">
            <router-link to="/product">عسل هزار گل</router-link>
          </li>
          <li class="footer-list__item">
            <router-link to="/product">عسل آویشن</router-link>
          </li>
          <li class="footer-list__item">
            <router-link to="/product">عسل گون</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer-footer">
      <div class="footer-footer-contact">
        <div class="footer-footer-contact__icon">
          <i class="fab fa-telegram"></i>
        </div>
        <div class="footer-footer-contact__icon">
          <i class="fab fa-twitter"></i>
        </div>
        <div class="footer-footer-contact__icon">
          <i class="fab fa-instagram"></i>
        </div>
        <div class="footer-footer-contact__icon">
          <i class="fab fa-whatsapp"></i>
        </div>
      </div>
      <div class="footer-footer-logo">
        <img src="../../public/image/logo.png" alt="logo" />
      </div>
      <div class="footer-footer-copyright">
        <p> 2020 Qode Interactive All Rights Reserved ©</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      showImageFooter: false,
    };
  },
  mounted() {
    let vh = (window.innerHeight * 4) / 5;
    window.addEventListener("scroll", () => {
      let topOfFooter = this.$refs.footer.getBoundingClientRect().top;

      if (topOfFooter < vh) {
        this.showImageFooter = true;
      }else{
        this.showImageFooter = false;

      }
    });
  },
};
</script>

<style></style>
